import { render } from "./readBookInfo.vue?vue&type=template&id=630e7b17&scoped=true"
import script from "./readBookInfo.vue?vue&type=script&lang=js"
export * from "./readBookInfo.vue?vue&type=script&lang=js"

import "./readBookInfo.vue?vue&type=style&index=0&id=630e7b17&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630e7b17"]])

export default __exports__